// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
//
import firebase from 'firebase'
import 'firebase/firestore'

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App :user="user" ></App>',
  components: { App },
  //
  data(){
    return {
      user : {}
    }
  },
  methods:{
    getLoginStatus(){
      let vm = this
      firebase.auth().onAuthStateChanged(function(user) {
        if (user) {
          vm.user = user
          console.log("// User is signed in by Phone Number : ", user.phoneNumber)
        } else {
          vm.user = null
          console.log("// No user is signed in.")
        }
      });
    },
    initFirebase(){
      const firebaseApp = firebase.initializeApp({
        apiKey: "AIzaSyAESXooEfeCjh2QqyLrWmZziG5O_3NHTpg",
        authDomain: "moijoy-10151.firebaseapp.com",
        projectId: "moijoy-10151",
        storageBucket: "moijoy-10151.appspot.com",
        messagingSenderId: "1001707392864",
        appId: "1:1001707392864:web:11c2f2f88919dbb793d805",
        measurementId: "G-99PWJLHDZJ"
      });
    },
  },
  updated(){
    this.getLoginStatus()
  },
  created(){
    this.initFirebase()
    this.getLoginStatus()
  }
})



// WEBPACK FOOTER //
// ./src/main.js